module.exports = __webpack_public_path__ + "static/media/avon-white-logo.d6faf8e7.svg";